"use client";
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";
import NumbersItem from "@/next-src/components/home/numbers-section/numbers-item/NumbersItem";

import comCSS from "./NumbersSection.module.scss";

const NumbersSection = ({ className = "", data }) => {
  const { width: windowWidth } = useWindowDimensions();
  const { bgColorMobile, items, paddingTopMobile, paddingBottomMobile } =
    data || {};

  let { bgColor, paddingTop, paddingBottom } = data || {};

  if (windowWidth < 992) {
    bgColor = bgColorMobile;
    paddingTop = paddingTopMobile;
    paddingBottom = paddingBottomMobile;
  }
  return (
    <section
      className={cn(className, comCSS.wrapper, "section")}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div
        className={cn("padding-global", comCSS.paddingWrapper)}
        style={{
          paddingTop:
            paddingTop !== null && paddingTop >= 0 ? `${paddingTop}px` : "",
          paddingBottom:
            paddingBottom !== null && paddingBottom >= 0
              ? `${paddingBottom}px`
              : "",
        }}
      >
        <div className="container-large">
          <div className="w-layout-grid _3-column-grid align-top">
            {items?.map((el) => (
              <NumbersItem key={el.id} data={el} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

NumbersSection.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string, // Unique identifier (consider making required)
        number: PropTypes.string, // Main numbered value
        numberMobile: PropTypes.string, // Mobile numbered value
        text: PropTypes.string, // Text content
        textMobile: PropTypes.string, // Mobile text content
      })
    ), // Make items array required
    paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingTopMobile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottomMobile: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    bgColor: PropTypes.string, // Background color
    bgColorMobile: PropTypes.string, // Mobile background color
  }),
};

export default NumbersSection;
